<template>
  <div>
    <div class="named-splitter">
      <ToolButton ghost v-on:click.stop="()=>ontoggle()">
        <i>
          <svg height="18px" viewBox="0 0 24 24" width="18px" v-if="hidden"><path d="M0 0h24v24H0z" fill="none"/><path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"/></svg>
          <svg height="18px" viewBox="0 0 24 24" width="18px" v-else><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"/></svg>
        </i>
        <slot name="title"></slot>
      </ToolButton>
    </div>
    <div v-if="!hidden" :class="'fillParent '+innerClass">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  import ToolButton from "./ToolButton.vue";
  export default {
    props: {
      hidden:{
        type: Boolean,
        default: false
      },
      ontoggle:{
        type: Function,
        default: undefined
      },
      innerClass:{
        type: String,
        default: ""
      }
    },
    components: {
      ToolButton
    },
    data() {
      return {
      }
    },

    watch: {

    },

    mounted() {
    },

    methods: {

    }
  }
</script>

<style scoped>
  .named-splitter{
    width: 100%;
    display: flex;
    align-items: center;
  }
  .named-splitter >>> >span{
    width: 100%;
    overflow: hidden;
  }
  .named-splitter >>> button{
    padding: 0;
    width: 100%;
    align-items: end;
    justify-content: flex-start;
  }
  .named-splitter >>> i{
    font-size: 16px !important;
    fill: #777;
    vertical-align: sub;
  }
  .named-splitter b{
    font-weight: 600;
    padding: 0 5px 0 0;
  }
  /*
  .named-splitter::before{
    flex: 1;
    height: 1px;
    border-top:1px dashed #D6D6D6;
    content: "";
  }
  .named-splitter::after{
    flex: 1;
    height: 1px;
    border-top:1px dashed #D6D6D6;
    content: "";
  }
  */
</style>